import React from "react";

const NoFound = () => {
  return <div>404</div>;
};

export default NoFound;
